import {Sport} from '@/types/common';
import {Box, Grid, Paper, Typography, useTheme} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {UserInOverview} from '.';

import StarIcon from '@mui/icons-material/Star';
import ResponsiveTypography from '@/components/ui/responsive-typography';

const SportsComponent: React.FC<{
  userData: UserInOverview;
}> = ({userData}) => {
  const theme = useTheme();

  const {t, i18n} = useTranslation();
  const defaultLanguage = 'de';
  const selectedLanguage: keyof Sport['labels'] =
    i18n.language || defaultLanguage;

  if (!userData.sports || userData.sports.length === 0) {
    return null;
  }

  return (
    <Grid item xs={12} style={{marginTop: '16px'}}>
      <Typography variant="h6" align={'center'}>
        {t('interests')}
      </Typography>
      <Box
        marginTop={2}
        width="100%"
        sx={{
          minWidth: {xs: '280px', md: '650px'}
        }}
      >
        <Grid container spacing={2}>
          {userData.sports.map((userSport, index) => {
            const sport = userSport.sport;
            return sport ? (
              <Grid item xs={12} md={6} key={index}>
                <Paper variant="outlined" sx={{my: 1, p: 2}}>
                  <Grid container alignItems="center">
                    <Grid item xs={7} sm={8} md={7}>
                      <ResponsiveTypography>
                        {sport.labels[selectedLanguage]}
                      </ResponsiveTypography>
                    </Grid>

                    <Grid item xs={5} sm={4} lg={5}>
                      <Grid
                        container
                        alignItems="center"
                        justifyContent="flex-end"
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            marginRight: '4px'
                          }}
                        >
                          {Array.from({length: 5}, (_, index) => (
                            <StarIcon
                              key={index}
                              color={
                                index < userSport.level ? 'primary' : 'disabled'
                              }
                              sx={{
                                color:
                                  index < userSport.level
                                    ? theme.palette.customColors?.overviewStars
                                    : undefined,
                                marginRight: '5px'
                              }}
                            />
                          ))}
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            ) : null;
          })}
        </Grid>
      </Box>
    </Grid>
  );
};

export default SportsComponent;
